import { InternalServerErrorComponent } from './out-of-application/InternalServerError/InternalServerError.component';
import { APP_BASE_HREF, DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { SelectModule } from 'primeng/select';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenubarModule } from 'primeng/menubar';
import { TooltipModule } from 'primeng/tooltip';
import { KeyFilterModule } from 'primeng/keyfilter';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { DatePickerModule } from 'primeng/datepicker';
import { CarouselModule } from 'primeng/carousel';
import { AppComponent } from './app.component';
import { DataService, UIBlockingStatus } from './common/data.service';
import { AuthGuardService } from './common/auth-guard.service';
import { AppTokenHandler } from './common/app-token-handler';
import { ErrorHandler } from '@angular/core';
import { AppErrorHandler } from './common/app-error-handler';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { WinAuthInterceptor } from './common/interceptor';
import { HomeComponent } from './inside-of-application/home/home.component';
import { DashboardComponent } from './inside-of-application/dashboard/dashboard.component';
import { BadRequestComponent } from '../app/out-of-application/bad-request/bad-request.component';
import { PageNotFoundComponent } from '../app/out-of-application/page-not-found/page-not-found.component';
import { LogoutComponent } from '../app/out-of-application/logout/logout.component';
import { UnAuthorizeComponent } from '../app/out-of-application/un-authorize/un-authorize.component';
import { SessionExpiredComponent } from './out-of-application/session-expired/session-expired.component';
import { LoginComponent } from './out-of-application/login/login.component';
import { DummyLoginComponent } from './out-of-application/dummy-login/dummy-login.component';
import { AlertComponent } from './out-of-application/alert/alert.component';
import { ProgressComponent } from './out-of-application/progress/progress.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AccordionModule } from 'primeng/accordion';
import { OrderListModule } from 'primeng/orderlist';
import { DataViewModule } from 'primeng/dataview';
import { ButtonModule } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { NgZorroAntdModuleModule } from './ng-zorro-antd-module.module';
import { CookieService } from 'ngx-cookie-service';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
registerLocaleData(en);
import { NZ_I18N, en_US} from 'ng-zorro-antd/i18n';
import { AzureAuthService } from './common/azure-auth.service';
import { LoginService } from './common/login.service';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RouterModule } from '@angular/router';
import { SharedModule } from './shared.module';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

@NgModule({ declarations: [
        AppComponent,
        BadRequestComponent, PageNotFoundComponent, LogoutComponent, UnAuthorizeComponent,
        SessionExpiredComponent, LoginComponent, DummyLoginComponent, AlertComponent, ProgressComponent,
        InternalServerErrorComponent,
        HomeComponent, DashboardComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule, BrowserAnimationsModule, ReactiveFormsModule, AppRoutingModule,
        ToastModule, MessageModule, SelectModule, CheckboxModule, MultiSelectModule, MenubarModule, TooltipModule,
        KeyFilterModule, DialogModule, TableModule, CardModule, DatePickerModule,
        CarouselModule, BlockUIModule, ProgressSpinnerModule, RadioButtonModule, FormsModule,
        AccordionModule, OrderListModule, DataViewModule, ButtonModule, TextareaModule,
        AutoCompleteModule,
        NgZorroAntdModuleModule,
        NzSpinModule,
        NgxSpinnerModule,
        RouterModule,
        SharedModule], providers: [
        DataService, AppTokenHandler, AuthGuardService, UIBlockingStatus, MessageService,
        { provide: HTTP_INTERCEPTORS, useClass: WinAuthInterceptor, multi: true },
        { provide: ErrorHandler, useClass: AppErrorHandler },
        { provide: NZ_I18N, useValue: en_US },
        DatePipe, CookieService,
        AzureAuthService,
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
        providePrimeNG({ theme: { preset: Aura } })
    ] })
export class AppModule { }